import { cloneElement } from "react";
import { twJoin } from "tailwind-merge";

import type { IconComponent } from "@/components/Icon/Icon";
import { buttonVariants } from "@/design-system/Button";
import { Stack } from "@/design-system/Stack";
import { twResolve } from "@/helpers/tw-resolve";

type CreateTicketModalOptionButtonProps = {
  title: string;
  description?: string;
  icon?: IconComponent;
  size?: "sm" | "md";
  "data-testid"?: string;
  onSelect: () => void;
};

export const CreateTicketModalOptionButton = ({
  title,
  description,
  icon,
  size = "md",
  "data-testid": dataTestId = "node-option-btn",
  onSelect,
}: CreateTicketModalOptionButtonProps): React.ReactNode => {
  return (
    <button
      data-testid={dataTestId}
      type="button"
      onClick={onSelect}
      className={twResolve(
        buttonVariants({
          variant: "soft",
        }),
        "flex h-fit w-full items-center justify-start gap-space-md p-space-md",
      )}
    >
      {icon &&
        cloneElement(icon, {
          size: 24,
        })}
      <Stack>
        <span className={twJoin("text-left", size === "md" && "text-body-emphasis", size === "sm" && "text-body")}>
          {title}
        </span>
        {description && (
          <span className="text-left text-caption whitespace-pre-wrap text-text-secondary">{description}</span>
        )}
      </Stack>
    </button>
  );
};
